/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CertificationSkillTranslation
 */
export interface CertificationSkillTranslation {
    /**
     * 
     * @type {string}
     * @memberof CertificationSkillTranslation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CertificationSkillTranslation
     */
    name?: string;
}

/**
 * Check if a given object implements the CertificationSkillTranslation interface.
 */
export function instanceOfCertificationSkillTranslation(value: object): value is CertificationSkillTranslation {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CertificationSkillTranslationFromJSON(json: any): CertificationSkillTranslation {
    return CertificationSkillTranslationFromJSONTyped(json, false);
}

export function CertificationSkillTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertificationSkillTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CertificationSkillTranslationToJSON(value?: CertificationSkillTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

